import React from "react";

function NotFound() {
  return (
    <div>
      <h1>Stránka nenalezena</h1>
    </div>
  );
}

export default NotFound;
